
import 'swiper/css';
import VideoModal from "../ModalVideo/VideoModal";


/* images */
import Slider1 from '../../images/hero-banner.jpg'
const Hero3 = () => {


    return (
      <section className="hero-slider">
        <div
          className="slide-inner slide-bg-image"
          style={{ backgroundImage: `url(${Slider1})` }}
        >
          <div className="container-fluid">
            <div className="slide-content">
              <div className="slide-title">
                <h2>
                  <span className="title-line-1">Soluciones</span>
                  <span className="title-line-2">Quirúrgicas Avanzadas</span>
                </h2>
                <div className="tagline-banner">
                  Somos su centro de excelencia en cirugías avanzadas.
                </div>
                <p>
                  Ofrecemos atención de vanguardia con tecnología de punta y técnicas
                  mínimamente invasivas, asegurando resultados óptimos,
                  recuperación rápida y máxima seguridad para nuestros
                  pacientes.
                </p>
              </div>
              <div className="slide-btns"></div>
            </div>
          </div>
          <div className="video">
            <VideoModal />
          </div>
        </div>
      </section>
    );
}

export default Hero3;

